import type { TFunction } from 'i18next';

export function getDeviceEventCategoryLabel(
  key: string,
  t: TFunction,
  fallback = key,
): string {
  return t(`monitoringDetail.eventsDetail.categories.${key}`, {
    defaultValue: fallback,
  });
}
